enum ApiReducerPath {
  API_APPROVALS = 'approvalsApi',
  API_LEAVE_REQUEST = 'leaveRequestApi',
  API_IT_REQUEST = 'itRequestApi',
  API_PASSPORT_REQUEST = 'passportRequestApi',
  API_GET_USER_INFO = 'userInfoApi',
  API_GET_DICTIONARY = 'dictionaryApi',
  API_MATERIAL_REQUEST = 'materialRequestApi',
  API_REQUISITION_PURCHASE_REQUEST = 'purchaseRequestApi',
  API_SALARY_CERTIFICATE = 'salaryCertificateApi',
  API_OVERSEAS_MISSION = 'overseasMissionApi',
  API_RESUMPTION_REQUEST = 'resumptionRequestApi',
  API_RESIGNATION_REQUEST = 'resignationRequestApi',
  API_BASIC_HRM_REQUEST = 'basicHrmRequestApi',
  API_ATTENDANCE_REQUEST = 'attendanceRequestApi',
  API_DMS = 'dmsApi',
  API_STRAPI = 'strapiApi',
  API_PERMISSIONS = 'permissionsApi',
  API_TENDER_REQUEST = 'tenderRequestApi',
  API_CHATBOT = 'chatbotApi',
  API_CONTACT = 'contactApi',
  API_PROFILE = 'profileApi',
}

export default ApiReducerPath;
